export default {"src":"/_next/static/media/NL.013db0a5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};